module.exports = __webpack_public_path__ + "static/media/brushsan-4.3740e4a0.png";